export default {
  Codigo: null,
  Descripcion: '',
  Activo: true,
};
